// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__5VUKY"};